const Table = (resolve) =>
  require.ensure([], () => resolve(require("./Table.vue")), "compete-projects");

export default [
  {
    path: "/school/compete/activities/:id/table",
    name: "school/compete/activities/show/table",
    component: Table,
    meta: {
      title: "汇总表",
      // layout: "school",
    },
  },
];



// WEBPACK FOOTER //
// ./src/pages/school/compete/activities/index.js